import { call, take, put }                  from 'redux-saga/effects';
import axios                                from 'axios';
import { CHANGE_MODAL_STATE, CREATE_ERROR } from '../actions'; 

const dev = process.env.NODE_ENV === 'development';
const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/submitMessage.php';


function* submitMessage(): Generator<any,any,any> {
  while(true) {
    try {

        const userInput = yield take('SUBMIT_MESSAGE_SAGA');
        yield put(CHANGE_MODAL_STATE('loader')); 

        const { payload }    = userInput;
        const { freezModal } = payload;

        console.log('payload : ',payload )

        if (dev) {
            yield put(CHANGE_MODAL_STATE(freezModal ? 'freezModal' : 'messageSent')); 
        }
        else {

            const res = yield call( axios.post, endpoint, payload );

            console.log('res       :   ',res)
            console.log('res.data  :   ',res.data)
     
            if (res && res.data && res.data.success && res.data.success === 1 ) {
                yield put(CHANGE_MODAL_STATE(freezModal ? 'freezModal' : 'messageSent')); 
            }
            else {
              if (freezModal) {
                yield put(CHANGE_MODAL_STATE('loader')); 
              }
              else {
                yield put(CREATE_ERROR());
              }
              console.log('err in submit message saga')
            }

        }
    }
    catch(err) {
      yield put(CREATE_ERROR());
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default submitMessage;


